import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { Action, Mutation, Getter } from 'vuex-class'

import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import { cityParser } from '@/plugins/city_parser'
import Loading from '@/components/loading/loading';

@Component({
  components: {
    Modal,
    SkeletonFluid,
    Loading
  }
})
export default class ModalCities extends Vue {
  @Prop({ default: false }) show!: Boolean

  // Actions
  @Action action_getCountry
  @Action action_putUserOnly
  @Action action_getCity
  @Action action_changeUserCommerce
  @Action action_cleanCart
  @Action action_getCountries
  @Action action_getCities

  // Mutations
  @Mutation IS_SELECT_COUNTRY: any
  @Mutation SPINNER
  @Mutation CART: any

  // Getters
  @Getter getIsToken
  @Getter getCity
  @Getter getCities

  isLoading = true;

  get getSortedCities() {
    const sortFunction = (a, b) => {
      if(a.name < b.name) {
        return -1;
      }
      if(a.name > b.name) {
        return 1;
      }
      return 0;
    };
    return this.getCities.sort(sortFunction);
  }

  async mounted() {
    try { 
      this.isLoading = true;
      await this.action_getCountries();
      await this.action_getCities();
      this.isLoading = false;
    } catch (error) {
      this.$swal({
        title: "Error al cargar la información",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo"
      });
      this.IS_SELECT_COUNTRY(true);
    }
  }

  isCurrentCity(cityId) {
    if(cityId == this.getCity.id) {
      return true;
    }
    return false;
  }

  async _selectCountry(id, city, disable) {
    if (!disable) {
      return;
    }
    if(!this.isCurrentCity(city)) {
      try {
        this.SPINNER(true)
        await this.action_getCountry(id)
        this.IS_SELECT_COUNTRY(true)
        this._close();
  
        await this.action_cleanCart();
        const res = await this.action_getCity(city);
        const city_id = cityParser(res.commercial_name);
        if (
          (this.$route.params.city_id && this.$route.params.city_id !== city_id) ||
          !this.$route.params.city_id
        ) {
          this.$router.replace({ params: { city_id } });
        }
        this.SPINNER(false);
        this.$router.go(0);
      } catch (error) {
        this.SPINNER(false)
      }
    } else {
      this.IS_SELECT_COUNTRY(true)
      this._close();
    }
  }

  _close () {
    this.$emit('close')
    const paramsCity = this.$route.params.city_id;
    let currentCityName = "";
    if(this.getCity && this.getCity.commercial_name) {
      currentCityName = cityParser(this.getCity.commercial_name);
    }
    if(currentCityName && currentCityName.length && paramsCity !== currentCityName) {
      this.$router.replace({ params: {
        city_id: currentCityName
      }});
    }
  }
}
